import { useState } from "react";
import useSearch from "../../hooks/useSearch";
import SearchType from "../../interfaces/SearchType";
import IInputProps, { ISlimInputProps } from "./IInputProps";
import InputContainer, { InputContainerRow } from "./InputContainer";
import InputWithSearch from "./InputWithSearchFormikString";

export default <T,>({ name, label, formik }: IInputProps<T, string>) => {
    return (
        <InputContainer name={name} label={label} formik={formik}>
            <AddressInputSlim name={name} formik={formik} />
        </InputContainer>
    );
}

export const AddressInputRow = <T,>({ name, label, formik }: IInputProps<T, string>) => {
    return (
        <InputContainerRow name={name} label={label} formik={formik}>
            <AddressInputSlim name={name} formik={formik} />
        </InputContainerRow>
    );
}

export const AddressInputSlim = <T,>({ name, formik }: ISlimInputProps<T, string>) => {
    const [query, setQuery] = useState(formik.values[name] as string || "");
    const searchResult = useSearch(query, SearchType.Address);

    return (
        <InputWithSearch
            name={name}
            formik={formik}
            debouncedOnChange={setQuery}
            searchResult={{
                query: query,
                items: searchResult.foundLocations?.map(l => l.address) || [],
            }}
            showNewLabel={false}
        />
    );
}